import { NativeWebRTCAdapter } from './nativeWebRTCAdapter';
import { TwilioVoiceAdapter } from './twilioVoiceAdapter';
import { FreeswitchVoiceAdapter } from './freeswitchVoiceAdapter';

class CallManager {
  constructor() {
    this.adapter = null;
  }

  initialize(provider, options = {}) {
    if (this.adapter) {
      this.adapter.disconnect();
    }

    switch (provider) {
      case 'native_webrtc':
        this.adapter = new NativeWebRTCAdapter(options);
        break;
      case 'twilio':
        this.adapter = new TwilioVoiceAdapter(options);
        break;
      case 'freeswitch':
        this.adapter = new FreeswitchVoiceAdapter(options);
        break;
      default:
        throw new Error(`Unsupported calling provider: ${provider}`);
    }

    return this.adapter;
  }

  getAdapter() {
    return this.adapter;
  }
}

export default new CallManager();
